import { render, staticRenderFns } from "./RelatorioFornecedorPreview.vue?vue&type=template&id=9099b220&scoped=true"
import script from "./RelatorioFornecedorPreview.vue?vue&type=script&lang=js"
export * from "./RelatorioFornecedorPreview.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFornecedorPreview.vue?vue&type=style&index=0&id=9099b220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9099b220",
  null
  
)

export default component.exports